
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/extras-cover/all/add",
      function () {
        return require("private-next-pages/health-insurance/extras-cover/all/add/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/extras-cover/all/add"])
      });
    }
  